import { NotificationType } from "./notification-type";

export class Notification {
    text: string;
    type: NotificationType;
    duration?: number;

    constructor(text: string, type: NotificationType, duration?: number) {
        this.text = text;
        this.type = type;
        this.duration = duration;
    }
}